import { render, staticRenderFns } from "./ModalUbahTujuan.vue?vue&type=template&id=3604069b&scoped=true"
import script from "./ModalUbahTujuan.vue?vue&type=script&lang=js"
export * from "./ModalUbahTujuan.vue?vue&type=script&lang=js"
import style0 from "./ModalUbahTujuan.vue?vue&type=style&index=0&id=3604069b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3604069b",
  null
  
)

export default component.exports